<template>
  <div class="page-container">
    <div class="query-title">价格主数据查询与修改</div>

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <template slot="button">
            <table-button tip="导出" name="export" @click="exportExcel" />
            <table-button v-if="$_has(['WLY023', 'WLY024'])" name="add" tip="新增" @click="addPrice('CUS80200')" />
            <el-dropdown v-else trigger="hover" @command="addPrice">
              <table-button name="add" tip="新增" />
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="CUS80100">客户价</el-dropdown-item>
                <el-dropdown-item command="CUS80200">中心价</el-dropdown-item>
                <el-dropdown-item command="CUS80300">出厂价</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <table-button v-if="!$_has(['WLY023'])" name="cancle" tip="批量作废" @click="batchInvalid" />
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="rowClassName"
            @filter-change="filterChangeEvt"
          >
            <template #product_id="{row}">
              <span class="blue" @click="toDetail(row)">{{ row.product_id }}</span>
            </template>
          </vxe-grid>
        </Table-filter>
      </div>
    </div>

    <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />

  </div>
</template>

<script>
import { getPriceList, apiPriceBatchinValid } from '@/api/sap/client-sap'
import tableMixins from '@/utils/tableMixins'
import pageConfig, { pageSearch } from './config/priceQuery'
import { frontExport, concurrencyReq } from '@/utils/frontExport'
export default {
  mixins: [tableMixins],
  data() {
    return {
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [
          { type: 'checkbox', title: '', field: 'checkbox', width: 50 }
        ],
        data: []
      },
      pageSearch,
      searchField: {},
      isSetFilter: false
    }
  },
  created() {
    this.initPage(pageConfig)
  },
  methods: {
    addPrice(kotabnr) {
      this.$router.push({
        path: '/wly/master-data-price/maintenance',
        query: {
          type: 'add',
          kotabnr: kotabnr
        }
      })
    },
    toDetail(row) {
      this.$router.push({
        path: '/wly/master-data-price/price-check',
        query: {
          id: row.varnumh,
          kotabnr: row.kotabnr
        }
      })
    },
    // 导出全部 导出本页
    async exportExcel() {
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        ...this.allConditions
      }
      const data = await concurrencyReq(this.pagination.totalCount, params, getPriceList)
      frontExport(this.gridOptions.columns, data, '价格主数据')
    },
    async batchInvalid() {
      const data = this.$refs.xTable.getCheckboxRecords()
      const params = {
        PRICES: data
      }
      const res = await apiPriceBatchinValid(params)
      if (res.MSGTYPE === 'S') {
        this.queryData()
        return this.$message.success(res.MESSAGE)
      } else {
        return this.$message.warning(res.MESSAGE)
      }
    },
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          // 保存 查询组件的查询参数
          this.ranges = ranges
          this.handleRanges(ranges)
        }
        this.isSetFilter = false
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        ...this.allConditions,
        ...this.pagination,
        is_result: 1,
        sort: this.sortData.concat(this.tableSort)
      }

      this.loading = true
      try {
        const { data, total, calculation, field } = await getPriceList(params)
        if (data.length === 0 && (total - 0)) {
          this.queryData(1, ranges)
          return
        }
        this.pagination.totalCount = total - 0
        this.calculation = this.filtercalculation(calculation)
        // 更新计算值
        this.updateCount()
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(data)
        } else {
          this.gridOptions.data = data.concat(this.tableCountData)
        }
        this.allOptions = this.filterAllOptions(field)
        this.setFilter()
      } catch (e) {
        //
      }
      this.loading = false
    },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    }
  }
}
</script>
<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/price-manage/priceQuery.vue